



















import { Component, Vue } from 'vue-property-decorator'
import config from '@/config'
import { t } from '@/language'
import { getStorage } from '@/service/localStorage.service'
import { incognitoMode } from '@/service/embedPlayer.service'
import Nav from '@/components/Nav/index.vue'
import Loader from '@/components/Loader/index.vue'
import '@/assets/style/base.less'

@Component({
  components: {
    Nav,
    Loader
  }
})

export default class Application extends Vue {
  // __CREATED
  public created (): void {
    const locale: string = getStorage(config.APP_LANG) || navigator.language
    if (locale !== 'en-US') t(locale)

    incognitoMode()
    if (this.auth) this.$store.dispatch('APP.AUTH/User')
  }

  // __COMPUTED
  private get auth (): boolean {
    return this.$store.getters['APP.AUTH/auth']
  }

  private get load (): boolean {
    return this.$store.getters['APP.DEMO/load']
  }
}
